<template>
  <!-- 遮罩层 -->
  <div class="dialog-mask" v-if="visible" @click.self="closeDialog">
    <!-- 卡片主体 -->
    <div class="service-card">
      <!-- 顶部图片头部 -->
      <div class="card-header">
        <img class="header-img" :src="headerImgUrl" alt="头部背景图" />
        <div class="header-text-wrap">
          <!--  class="header-title" -->
            <h2>{{ title }}</h2>
            <span class="close" @click="closeDialog">×</span>
        </div>
      </div>
      <!-- 正文内容区 -->
      <div class="card-body">
        <p class="body-desc">{{ desc }}</p>
        <div class="item-list">
          <p class="list-item" v-for="(item, idx) in contentList" :key="idx">
            {{ item }}
          </p>
        </div>
        <div style="display: flex;flex-direction: column;justify-content: center;align-items: center;">
            <div style="display: flex;flex-direction: column;margin-top: 10px;    width: 100%;    align-items: center;">
                <span style="width: 100%;margin: 20px 0;font-size: 15px;font-weight: 600;">力学性能检测</span>
                <div style="display: flex;width: 100%;align-items: center;justify-content: center;">
                    <img src="@/assets/img/jiaju/server1.png" style="height: auto;width: 32%;object-fit: contain;" alt="">
                </div>
                <div style="width: 100%;">
                    <span style="white-space: break-spaces;display: flex;line-height: 1.5;text-align: left;font-size: 13px;margin-top: 10px;">
                        1.服务检测
                        <br>
                        &nbsp;&nbsp;依据GB/T 10357系列家具力学性能试验试验标准进行检测
                        <br>
                        2、送样信息
                        <br>
                        &nbsp;&nbsp;需送完整样品进行有损检测，可退样
                        <br>
                        3、检验项目
                        <br>
                        &nbsp;&nbsp;耐久性、强度
                        <br>
                        4、检测周期
                        <br>
                        &nbsp;&nbsp;10-15个工作日
                        <br>
                        5、检测价格
                        <br>
                        &nbsp;&nbsp;面议
                    </span>
                </div>
            </div>
            <div style="display: flex;flex-direction: column;margin-top: 10px;    width: 100%;    align-items: center;">
                <span style="width: 100%;margin: 20px 0;font-size: 15px;font-weight: 600;">可迁移有害元素检测</span>
                <img src="@/assets/img/jiaju/server2.png" style="height: 250px;width: 300px;" alt="">
                <div style="width: 100%;">
                    <span style="white-space: break-spaces;display: flex;line-height: 1.5;text-align: left;font-size: 13px;margin-top: 10px">
                        1.服务检测
                        <br>
                        &nbsp;&nbsp;依据GB/T6675.4-2014进行检测
                        <br>
                        2、送样信息
                        <br>
                        &nbsp;&nbsp;需送样品试件进行破坏性检测，可退样
                        <br>
                        3、检验项目
                        <br>
                        &nbsp;&nbsp;可迁移有害元素
                        <br>
                        4、检测周期
                        <br>
                        &nbsp;&nbsp;10-30个工作日
                        <br>
                        4、检测价格
                        <br>
                        &nbsp;&nbsp;面议

                    </span>
                </div>
            </div>
            <div style="display: flex;flex-direction: column;margin-top: 10px;    width: 100%;    align-items: center;">
                <span style="width: 100%;margin: 20px 0;font-size: 15px;font-weight: 600;">物理项目检测</span>
                <div style="display: flex;align-items: center;justify-content: center;">
                    <img src="@/assets/img/jiaju/server31.png" style="height: auto;width: 32%;object-fit: contain;" alt="">
                    <img src="@/assets/img/jiaju/server32.png" style="height: auto;width: 32%;object-fit: contain;" alt="">
                </div>
                <div style="width: 100%;">
                    <span style="white-space: break-spaces;display: flex;line-height: 1.5;text-align: left;font-size: 13px;margin-top: 10px">
                        1.服务检测
                        <br>
                        &nbsp;&nbsp;依据GB/T17657-2022进行检测
                        <br>
                        2、送样信息
                        <br>
                        &nbsp;&nbsp;需送样品试件进行破坏性检测，不可退样
                        <br>
                        3、检验项目
                        <br>
                        &nbsp;&nbsp;耐磨性、耐冲击、耐划痕、胶合强度等
                        <br>
                        4、检测周期
                        <br>
                        &nbsp;&nbsp;10-30个工作日
                        <br>
                        5、检测价格
                        <br>
                        &nbsp;&nbsp;面议
                    </span>
                </div>
            </div>
            <div style="display: flex;flex-direction: column;margin-top: 10px;    width: 100%;    align-items: center;">
                <span style="width: 100%;margin: 20px 0;font-size: 15px;font-weight: 600;">有害物质检测</span>
                <div style="    display: flex;justify-content: space-between;width: 100%;">
                    <img src="@/assets/img/jiaju/server41.png" style="height: auto;width: 32%;object-fit: contain;" alt="">
                    <img src="@/assets/img/jiaju/server42.png" style="height: auto;width: 32%;object-fit: contain;" alt="">
                    <img src="@/assets/img/jiaju/server43.png" style="height: auto;width: 32%;object-fit: contain;" alt="">
                </div>
                <div style="width: 100%;">
                    <span style="white-space: break-spaces;display: flex;line-height: 1.5;text-align: left;font-size: 13px;margin-top: 10px">
                        1.服务检测
                        <br>
                        &nbsp;&nbsp;依据GB/T18584-2024进行检测
                        <br>
                        2、送样信息
                        <br>
                        &nbsp;&nbsp;需送完整样品进行无损检测，可退样
                        <br>
                        3、检验项目
                        <br>
                        &nbsp;&nbsp;甲醛释放量、苯系物、TVOC总量
                        <br>
                        4、检测周期
                        <br>
                        &nbsp;&nbsp;20-30个工作日
                        <br>
                        5、检测价格
                        <br>
                        &nbsp;&nbsp;面议
                    </span>
                </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ServiceDialog",
  props: {
    // 弹窗显示控制
    visible: {
      type: Boolean,
      default: false
    },
    // 顶部头部图片地址
    headerImgUrl: {
      type: String,
      default: "@/assets/img/service-header.png"
    },
    // 标题
    title: {
      type: String,
      default: "检验检测服务"
    },
    // 顶部描述文字
    desc: {
      type: String,
      default: ""
    },
    // 列表内容
    contentList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    closeDialog() {
      this.$emit("update:visible", false);
      this.$emit("close");
    }
  }
}
</script>

<style scoped>
/* 遮罩层 灰色半透明背景 */
.dialog-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(120, 130, 150, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
/* 卡片整体 */
.service-card {
  width: 55%;
  border-radius: 16px;
  overflow: hidden;
  background: #ffffff;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.18);
}
/* 头部容器 */
.card-header {
  position: relative;
  width: 100%;
  height: 95px;
}
/* 顶部全屏图片 */
.header-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
/* 文字、关闭按钮容器，悬浮在图片上层 */
.header-text-wrap {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  box-sizing: border-box;
}
.header-text-wrap h2 {
  margin: 0;
  font-size: 20px;
  color: #ffffff; /* 白色文字适配深色背景图，可自行修改 */
}
.close {
  font-size: 26px;
  color: #fff;
  cursor: pointer;
}
.close:hover {
  color: #ff6666;
}
/* 左上角标题文字 */
.header-title {
  position: absolute;
  left: 40px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 28px;
  color: #ffffff;
  font-weight: 600;
  margin: 0;
}
/* 正文区域 */
.card-body {
  padding: 25px 35px;
  min-height: 180px;

  max-height: 670px;
  overflow: overlay;
}
.body-desc {
  font-size: 17px;
  color: #3B6CE2;
  margin: 0 0 10px;
  line-height: 1.2;
}
.item-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.list-item {
  font-size: 14px;
  color: #111111;
  margin: 0;
  font-weight: 600;
  line-height: 1.3;
}
</style>